import { useCallback, memo } from 'react';
import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import ApplicantsOverviewHiringStatusFilterEnum from '../../Models/ApplicantsOverviewHiringStatusFilterEnum';
import BaseFilterPanelContent from './BaseFilterPanelContent';
import CheckboxRow from './CheckboxRow';

function HiringStatusFilterPanel() {
    const options = Object.values(ApplicantsOverviewHiringStatusFilterEnum);

    const { hiringStatusFilter, filterByHiringStatus } = useCandidatesOverviewContext();

    const filterSelection = useCallback(
        (value: string): Array<ApplicantsOverviewHiringStatusFilterEnum> => {
            return hiringStatusFilter.filter((item: string) => item === value);
        },
        [hiringStatusFilter],
    );

    const isSelected = useCallback(
        (value: string): boolean => {
            return filterSelection(value).length > 0;
        },
        [hiringStatusFilter],
    );

    const handleChange = useCallback(
        (value: number) => {
            let current: Array<ApplicantsOverviewHiringStatusFilterEnum>;

            if (isSelected(options[value])) {
                current = hiringStatusFilter.filter((item) => item !== options[value]);
            } else {
                current = [...hiringStatusFilter, options[value]];
            }

            filterByHiringStatus(current);
        },
        [hiringStatusFilter],
    );

    const reset = useCallback(() => {
        filterByHiringStatus([]);
    }, []);

    return (
        <BaseFilterPanelContent resetCallback={reset}>
            <div className="flex flex-col">
                {options.map((item, index) => (
                    <CheckboxRow
                        key={item}
                        id={item}
                        menuItemLabel={item}
                        selected={isSelected(item)}
                        changeCallback={() => handleChange(index)}
                        className="h-10"
                    />
                ))}
            </div>
        </BaseFilterPanelContent>
    );
}

export default memo(HiringStatusFilterPanel);
